export const UI_SHAPE = {
  SQUARE: 'square',
  ROUND: 'round',
} as const;

export type UiShape = (typeof UI_SHAPE)[keyof typeof UI_SHAPE];
